import { formatCurrency } from 'src/utils';

const SMALLEST_SHOWN_COST = 0.01;

export const reasoningEffortLabel = (effort?: string | null): string => {
  const trimmed = effort?.trim();
  return trimmed
    ? trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
    : 'Not recorded';
};

/** One reply usually costs a fraction of a cent, which cents rounding would show as "$0.00". */
export const formatReplyCost = (value: number): string =>
  value > 0 && value < SMALLEST_SHOWN_COST
    ? `< ${formatCurrency(SMALLEST_SHOWN_COST, { precise: true })}`
    : formatCurrency(value, { precise: true });

export const countLabel = (
  count: number | undefined,
  singular: string,
): string => (count === 1 ? singular : `${singular}s`);

export const formatDurationMs = (value?: number | null): string =>
  value === undefined || value === null ? '—' : `${Math.round(value)} ms`;
